import { http } from '@/api/http';
import { ApiResponseBody } from '@/api/types';
import { getResourceReleaseNotesApiUrl } from './release-notes.paths';
import {
  ReleaseNote,
  ReleaseNotesResponse,
  CreateReleaseNotePayload,
  UpdateReleaseNotePayload,
} from '@/api/apis/release-notes';
import { ResourceReleaseNotesQueryParams } from './release-notes.types';

const getReleaseNotes = async (
  product: string,
  params: ResourceReleaseNotesQueryParams,
): Promise<ReleaseNotesResponse> => {
  const res = await http.get<ApiResponseBody<ReleaseNotesResponse>>(getResourceReleaseNotesApiUrl.list(product), {
    params,
  });
  return res.data.data;
};

const createReleaseNote = async (product: string, body: CreateReleaseNotePayload): Promise<ReleaseNote> => {
  const res = await http.post<ApiResponseBody<ReleaseNote>>(getResourceReleaseNotesApiUrl.list(product), body);
  return res.data.data;
};

const updateReleaseNote = async (
  product: string,
  releaseNoteId: string,
  body: UpdateReleaseNotePayload,
): Promise<ReleaseNote> => {
  const res = await http.put<ApiResponseBody<ReleaseNote>>(
    getResourceReleaseNotesApiUrl.byId(product, releaseNoteId),
    body,
  );
  return res.data.data;
};

const deleteReleaseNote = async (product: string, releaseNoteId: string): Promise<void> => {
  await http.delete(getResourceReleaseNotesApiUrl.byId(product, releaseNoteId));
};

export const resourceReleaseNotesApiFetcher = {
  getReleaseNotes,
  createReleaseNote,
  updateReleaseNote,
  deleteReleaseNote,
};
